import { get, post } from '../utils/axios'

export const getRightMenuProfileAPI = async () => {
  return await get('right/menu/profiles')
}

export const getRightMenuMainAPI = async (param) => {
  return await get('right/menu/main', param)
}

export const getRightMenuSubAPI = async (param) => {
  return await get('right/menu/sub', param)
}

export const getRightMenuCardMainAPI = async (param) => {
  return await get('right/menu/card/main', param)
}

export const getRightMenuCardSubAPI = async (param) => {
  return await get('right/menu/card/sub', param)
}

export const postRightMenuCardAPI = async (body) => {
  return await post('right/menu/card', body)
}

export const postRightMenuCardSubAPI = async (body) => {
  return await post('right/menu/card/sub', body)
}

export const getMyTokenAPI = async () => {
  return await get('my-token')
}
